import React from 'react'
import './css/NewHomeMenu.css'

const NewHomeMenu = () => {
  return (
    <div className='mx-auto rounded d-flex justify-content-around align-items-center p-2 my-4 home-menu-container'>
      <a href="" className='text-white home-menu-container-link'>Offers</a>
      <div className='divider' />
      <a href="" className='text-white home-menu-container-link'>Exams</a>
      <div className='divider' />
      <a href="" className='text-white home-menu-container-link'>Updates</a>
    </div>
  )
}

export default NewHomeMenu